import {
    IconDefinition,
    faChalkboard,
    faCalendar,
  } from "@fortawesome/free-solid-svg-icons";
  import {
      ADMINDASHBOARD,
    DASHBOARD,
  } from "./constants";
  
  export interface SideMenu {
    key: string;
    path: string;
    name: string;
    icon: IconDefinition;
  }
  
  export const sidemenu: SideMenu[] = [
    {
      key: "dashboard",
      path: DASHBOARD,
      name: "Dashboard",
      icon: faChalkboard,
    },
    {
      key: "call-listing",
      path: ADMINDASHBOARD,
      name: "Appointments",
      icon: faCalendar,
    }
  ];